import { gql } from "@apollo/client";

export const createComment = gql`
  mutation createComment($pageId: Int!, $comment: String!) {
    comments {
      create(pageId: $pageId, content: $comment) {
        id
        responseResult {
          message
          succeeded
          errorCode
          slug
        }
      }
    }
  }
`;
